<template>
  <div id="pages-login">
    <login-form />
  </div>
</template>

<script>
import LoginForm from '@/modules/LoginForm'

export default {
  name: 'login',
  data () {
    return {
      msg: 'Login',
    }
  },
  components: { LoginForm },
  methods: {
    cleanModals () {
      // remove unexpected modals which were opened before redirecting to Login
      const modals = Array.from($('.reveal-overlay'))
      // clean is-reveal-open class for body element when modals closed
      $('body').removeClass('is-reveal-open')
      modals.forEach(modal => {
        if ($(modal).css('display') !== 'none') {
          $(modal).remove()
        }
      })
    },
  },
  mounted () {
    this.cleanModals()
  },
}
</script>
